import type { ComponentType } from "react";
import { WebRoutes } from "consts/enpoints/web";
import { Navigate } from "infrastructure/router";
import useOnboardingApplication from "features/ecommerce/useOnboardingApplication";

export const withApplication = <TProps extends object>(Component: ComponentType<TProps>) =>
    (props: TProps) => {
        const { isApplicationStarted } = useOnboardingApplication();

        if (!isApplicationStarted()) {
            return (
                <Navigate
                    to={WebRoutes.Onboarding.Index}
                    replace
                />
            );
        }

        return (
            <Component
                {...props}
            />
        );
    };

export default withApplication;
